import { StyleSheet } from 'react-native';

export const createStyles = () =>
  StyleSheet.create({
    container: {
      flex: 1,
    },
    scroll: {
      padding: 20,
    },
    section: {
      marginBottom: 25,
    },
    label: {
      fontSize: 16,
      fontWeight: '600',
      marginBottom: 4,
    },
    labelHint: {
      fontSize: 13,
      marginBottom: 12,
    },
    input: {
      borderWidth: 1,
      borderRadius: 10,
      padding: 15,
      fontSize: 16,
    },
    textArea: {
      height: 80,
      textAlignVertical: 'top',
    },
    card: {
      borderWidth: 2,
      borderRadius: 12,
      padding: 15,
      marginBottom: 15,
      position: 'relative',
    },
    cardHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 8,
    },
    cardTitle: {
      fontSize: 18,
      fontWeight: 'bold',
    },
    cardDesc: {
      fontSize: 14,
      marginLeft: 40,
    },
    checkBadge: {
      position: 'absolute',
      top: 15,
      right: 15,
      width: 28,
      height: 28,
      borderRadius: 14,
      justifyContent: 'center',
      alignItems: 'center',
    },
    cancelBtn: {
      padding: 18,
      alignItems: 'center',
      marginTop: 10,
    },
    cancelBtnText: {
      fontSize: 16,
    },
    limitOptions: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      gap: 10,
    },
    limitOption: {
      paddingHorizontal: 16,
      paddingVertical: 10,
      borderRadius: 20,
      borderWidth: 1,
      minWidth: 60,
      alignItems: 'center',
    },
    limitOptionText: {
      fontSize: 14,
      fontWeight: '600',
    },
    fixedParticipantsNotice: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      borderWidth: 1,
      borderRadius: 10,
      padding: 12,
      marginTop: 8,
    },
    fixedParticipantsText: {
      fontSize: 13,
      flex: 1,
      lineHeight: 18,
    },
  });
